export enum Languages {
  VI = "VI",
  EN = "EN",
}
